import IconButton from '@mui/material/IconButton';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import StarRateIcon from '@mui/icons-material/StarRate';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import { useAppDispatch } from 'src/hooks';
import { IAppDrawerNav, setFavoriteStatusForPages } from './app-drawer-slice';
import { RouteLink } from 'src/components/analytics/index';
import './app-drawer.scss';
import { Parent } from './types/auth-response.model';
import Storage from 'src/utils/storage/storage';
import { toggleFavorite } from 'src/pages/analytics/landing/store/landing-slice';
import { getFavoritePayload } from './utils';

export interface IListItem {
  itemIndex: number;
  navOption: IAppDrawerNav;
  open: boolean;
  isActive: boolean;
  getActiveItem: any;
}

interface IChildObj {
  parent: Parent;
  children: IChildObj[];
}

export default function ChildItem({
  childObj,
  currentRouteUrl,
  activeLinkColor,
  linkColor
}: {
  childObj: IChildObj;
  currentRouteUrl: string;
  activeLinkColor: string;
  linkColor: string;
}) {
  // local state for toggling favorite icon
  const [isFavorite, setIsFavorite] = useState(childObj.parent.is_favourite);

  //   local state for loader while calling favorite api
  const [isFavoriteLoading, setIsFavoriteLoading] = useState(false);

  const { source: sourceId } = Storage.getSourceId();

  const appDispatch = useAppDispatch();

  // handler for toggling favorite
  const handleToggleFavorite = () => {
    // setting loader true while calling the api
    setIsFavoriteLoading(true);

    // getting the formatted payload
    const favPayload = getFavoritePayload(childObj.parent, !isFavorite);
    // calling the favorite api for toggling the item as favorite
    appDispatch(toggleFavorite({ ...favPayload, sourceID: sourceId }))
      .then(() => {
        setIsFavorite(isFavorite === 1 ? 0 : 1);
        setIsFavoriteLoading(false);

        // updating pages data on favorite click
        appDispatch(
          setFavoriteStatusForPages({
            pageName: childObj.parent.name,
            isFavoriteValue: isFavorite === 1 ? 0 : 1
          })
        );
      })
      .catch((error) => {
        setIsFavoriteLoading(false);
      });
  };

  return (
    <div className='nav-link-item'>
      {childObj.parent.is_pb_page && (
        <div className='fav-icon-div'>
          <IconButton
            aria-label='add to favorites'
            onClick={handleToggleFavorite}
          >
            {isFavoriteLoading ? (
              <CircularProgress size={16} />
            ) : isFavorite ? (
              <StarRateIcon sx={{ fontSize: '20px', color: '#0000a0' }} />
            ) : (
              <StarOutlineIcon sx={{ fontSize: '20px' }} />
            )}
          </IconButton>
        </div>
      )}
        <RouteLink
          key={childObj.parent.name}
          link={childObj.parent.route_url}
          description={childObj.parent.alias}
          color={
            currentRouteUrl.includes(childObj.parent.route_url)
              ? activeLinkColor
              : linkColor
          }
        />
    </div>
  );
}
